import { Box } from '@mui/material';
import { AlertBoxMsg } from '@qrios/frontend-library';
import { DeleteForeverOutlined } from '@mui/icons-material';

import { DialogError } from '../../../business-error';
import locales from '../../../../../constants/locales';
import { DialogActionButtons, DialogDescription } from '../../../dialog';

import { DeletedReport } from './interfaces';
import { getDialogReportStatus } from '../utils/helpers';

interface Props {
  loading: boolean;
  report: DeletedReport | undefined;
  error: DialogError;
  handleDeleteReport: () => void;
  handleCloseDeleteDialog: () => void;
}

const DeleteReportDialog = ({ loading, report, error, handleDeleteReport, handleCloseDeleteDialog }: Props) => {
  const actions = {
    primary: {
      type: 'button' as const,
      handler: handleDeleteReport,
      text: locales.button.title.delete
    },
    secondary: {
      type: 'button' as const,
      handler: handleCloseDeleteDialog,
      text: locales.button.title.close
    }
  };

  return report ? (
    <Box minHeight="200px" display="flex" flexDirection="column" justifyContent="space-between">
      <DialogDescription icon={DeleteForeverOutlined}>
        You want to delete {getDialogReportStatus(report.status)} <b>{report.name}</b> report completely. This operation
        cannot be undone. Click <b>Delete</b> to confirm.
      </DialogDescription>
      {error ? (
        <Box pt={2}>
          <AlertBoxMsg severity={error.severity}>{error.message}</AlertBoxMsg>
        </Box>
      ) : null}
      <DialogActionButtons actions={actions} loading={loading} danger={true} />
    </Box>
  ) : null;
};

export default DeleteReportDialog;
